// extracted by mini-css-extract-plugin
export var avatar = "_lt-3";
export var avatarContainer = "_lt-2";
export var avatarSpacer = "_lt-5";
export var avatarSpacerContainer = "_lt-4";
export var avatarStackContainer = "_lt-1";
export var bubble = "_lt-0";
export var remainderBubble = "_lt-6";